<template>
    <b-card>
        <b-row>
            <b-col lg="12">
                <b-card header="Select Date Range"
                        header-text-variant="white"
                        header-bg-variant="info"
                >
                    <b-form inline @submit.prevent="loadStats()" class="d-flex justify-content-between align-items-center">

                        <div class="d-flex align-items-center">
                            <date-picker
                                    v-model="start_date"
                                    placeholder="Start Date"
                                    class="f-1"
                            >
                            </date-picker> &nbsp;to&nbsp;
                            <date-picker
                                    v-model="end_date"
                                    placeholder="End Date"
                                    class="f-1"
                            >
                            </date-picker>
                            <carrier-dropdown v-model="carrier" :withEmpty="true" emptyText="-- All Carriers --" class="ml-2" v-if=" !carrier_preselect"></carrier-dropdown>
                        </div>

                        <b-button type="submit" variant="info" :disabled="loading">Generate</b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>

        <div class="table-responsive">

            <loading-card v-if="loading"></loading-card>

            <table class="table table-bordered table-striped table-condensed" v-if=" !loading && stats.visits ">
                <tbody>
                <!-- Visits -->
                <tr>
                    <th>Total Visits</th>
                    <td>{{ thousandsFormat(stats.visits.total) }}</td>
                </tr>
                <tr>
                    <th class="indented">Visits - EVV</th>
                    <td>{{ thousandsFormat(stats.visits.evv) }}</td>
                </tr>
                <tr>
                    <th class="indented">Visits - TVV</th>
                    <td>{{ thousandsFormat(stats.visits.telephony) }}</td>
                </tr>
                <tr>
                  <th class="indented">Mobile Visits</th>
                  <td>{{ thousandsFormat(stats.visits.mobile) }}</td>
                </tr>
                <tr>
                    <th class="indented">Verified Visits</th>
                    <td>{{ thousandsFormat(stats.visits.verified) }}</td>
                </tr>
                <tr>
                    <th class="indented">In Progress Visits</th>
                    <td>{{ thousandsFormat(stats.visits.in_progress) }}</td>
                </tr>
                <tr>
                    <th class="indented">Unverified Visits</th>
                    <td>{{ thousandsFormat(stats.visits.unverified) }}</td>
                </tr>
                <tr>
                    <th>Verified Visit %</th>
                    <td>{{ percentageFormat(stats.visits.verified_pct) }}</td>
                </tr>
                <tr>
                    <th>Unverified Visit %</th>
                    <td>{{ percentageFormat(stats.visits.unverified_pct) }}</td>
                </tr>
                <tr>
                    <th>Recorded Hours</th>
                    <td>{{ numberFormat(stats.visits.hours) }}</td>
                </tr>
                <!-- Invoices -->
                <tr>
                    <th>Total Invoices Submitted</th>
                    <td>{{ thousandsFormat(stats.invoices.submitted) }}</td>
                </tr>
                <tr>
                    <th class="indented">Claimants Submitting</th>
                    <td>{{ thousandsFormat(stats.invoices.claimants) }}</td>
                </tr>
                <tr>
                    <th>Amount of Care Recorded</th>
                    <td>{{ moneyFormat(stats.visits.cost) }}</td>
                </tr>
                <!-- Falls -->
                <tr>
                    <th>Reported Falls</th>
                    <td>{{ thousandsFormat(stats.visits.falls) }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </b-card>
</template>

<script>

    import FormatsDates from "../../../mixins/FormatsDates";
    import FormatsNumbers from "../../../mixins/FormatsNumbers";
    import ScopesToCarrier from "../../../mixins/ScopesToCarrier";
    import UsesRole from "../../../mixins/UsesRole";

    export default {

        mixins: [ FormatsDates, FormatsNumbers, ScopesToCarrier, UsesRole ],

        props: {

            'defaults': [Object, Array],
            carrier_preselect: {

                type     : String,
                default  : '',
                required : false
            }
        },

        data() {
            return {
                start_date: this.getDefault('start_date', moment().subtract('7', 'days').startOf('isoweek').format('MM/DD/YYYY')),
                end_date: this.getDefault('end_date', moment().subtract('7', 'days').endOf('isoweek').format('MM/DD/YYYY')),
                carrier: '',
                stats: {},
                loading: false,
            }
        },

        mounted() {
        },

        computed: {

        },

        methods: {

            async loadStats() {
                try {
                  this.loading = true;
                  let url = `/${this.controller}/reports/status?json=1&carrier=${this.carrierId}&start_date=${this.start_date}&end_date=${this.end_date}`;
                  const response = await axios.get(url);
                  this.stats = response.data;
                } catch (ex) {
                  const message = ex.response.data.message || ex.message || 'Error';
                  alerts.addMessage( 'error', message);
                } finally {
                  this.loading = false;
                }
            },

            getDefault(field, defaultValue = '') {
                if (this.defaults && this.defaults[field]) {
                    return this.defaults[field];
                }
                return defaultValue;
            },

        }
    }
</script>

<style>
    th.indented {
        font-weight: normal;
        padding-left: 20px;
    }
</style>
